import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 语法分析结果展示组件
 * 以卡片形式展示分析结果，支持加载和空状态
 */
export const GrammarAnalysisView = ({ analysisText, isLoading = false, className = '', }) => {
    const renderGrammarContent = () => {
        if (isLoading) {
            return _jsx("span", { className: "text-gray-500 italic", children: "Analyzing..." });
        }
        if (!analysisText) {
            return _jsx("span", { className: "text-gray-500 italic", children: "No grammar analysis available." });
        }
        return analysisText;
    };
    return (_jsxs("div", { className: `bg-white rounded-lg shadow-md p-0.5 flex flex-col ${className}`, children: [_jsx("h3", { className: "text-sm font-medium text-interactive-stone-gray mb-1", children: "Grammar Analysis" }), _jsx("div", { className: "bg-interactive-sunset-orange-50 rounded-lg p-0.5 border border-interactive-sunset-orange-200 overflow-y-auto flex-1 min-h-0", children: _jsx("div", { className: "text-sm text-interactive-stone-gray whitespace-pre-wrap", children: renderGrammarContent() }) })] }));
};
// 添加默认导出以兼容旧代码
export default GrammarAnalysisView;
//# sourceMappingURL=GrammarAnalysisView.js.map